import { render, staticRenderFns } from "./CreateCreditInvoiceDispatchOrderFrame.vue?vue&type=template&id=95ec7d5c&scoped=true&"
import script from "./CreateCreditInvoiceDispatchOrderFrame.vue?vue&type=script&lang=js&"
export * from "./CreateCreditInvoiceDispatchOrderFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ec7d5c",
  null
  
)

export default component.exports